import { useState, useEffect } from "react"
import useApiResource from "./use_api_resource"

const useApi = ({ path, app = "registrations", data = {} }) => {
  const resource = useApiResource({ path, data, app })

  const [loading, setLoading] = useState(true)
  const [errors, setErrors] = useState(null)
  const [response, setResponse] = useState(null)
  const [meta, setMeta] = useState(null)

  useEffect(() => {
    const fetch = async () => {
      setLoading(true)
      await get()
      setLoading(false)
    }

    fetch()
  }, [])

  const get = async () => {
    try {
      const response = await resource.index()
      setResponse(response.data)
      setMeta(response.meta)
    } catch (error) {
      setErrors(error.errors)
    }
  }

  const create = async (attributes, data = {}) => {
    try {
      return resource.create(attributes, data)
    } catch (error) {
      return error
    }
  }

  const update = async (id, attributes, data = {}) => {
    try {
      return await resource.update(id, attributes, data)
    } catch (error) {
      return error
    }
  }

  const destroy = async (id, data = {}) => {
    try {
      const response = await resource.destroy(id, data)
      return response ?? {}
    } catch (error) {
      return error
    }
  }

  const mutate = async ({ id, ...attributes }, data) => {
    if (id) return update(id, attributes, data)
    return create(attributes, data)
  }

  return { loading, errors, response, meta, get, mutate, destroy }
}

export default useApi
